import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
import OilImageGallery from "./components/OilImageGallery/OilImageGallery";
import OilProductSelection from "./components/OilProductSelection/OilProductSelection";
import OilProductDescription from "./components/OilProductDescription/OilProductDescription";
import OilDetailsAccordion from "./components/OilDetailsAccordion/OilDetailsAccordion";
import OilFAQ from "./components/OilFAQ/OilFAQ";
import OilContactSection from "./components/OilContactSection/OilContactSection";
import OilStickyBar from "./components/OilStickyBar/OilStickyBar";
import OilShareModal from "./components/OilShareModal/OilShareModal";
import MobilePageHeader from "./components/MobilePageHeader/MobilePageHeader";
import BreadCrumb from "@componentsShared/BreadCrumb";
import useTranslation from "@/i18n/useTranslation";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import { useCart } from "@/common/Contexts/CartContext";
import { trackEvents } from "@/common/events/events";
import useBFCacheBuster from "@hooks/useBFCacheBuster";
var OilDetailPage = function OilDetailPage() {
  var _ref, _gallery$title, _ref2, _gallery$content$;
  var data = useFullPageData(PageNamesEnum.PAGE_NAME__OilDetailPage);
  var _useTranslation = useTranslation(["web_oils"]),
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateToHard = _useHelpers.navigateToHard;
  var isMobile = useIsMobile();
  var _useState = useState(false),
    showShare = _useState[0],
    setShowShare = _useState[1];
  var _useCart = useCart(),
    seedCart = _useCart.seedCart;

  // Force reload on browser back so removed cart items don't reappear from bfcache.
  useBFCacheBuster();
  useEffect(function () {
    if (!checkFeatureFlag("FF_ENABLE_OIL_COUPON")) {
      navigateToHard('/?ref=referral_404');
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (!data) return;
    var cartBlocks = data.filter(function (b) {
      return b.component_type === "cart_items" || b.component_type === "cart_summary" || b.component_type === "cart_cta";
    });
    if (cartBlocks.length > 0) seedCart(cartBlocks);
    var options = data.find(function (c) {
      return c.component_type === "product_options";
    });
    if (options) {
      var _URLSearchParams, _window, _window$location;
      trackEvents("vas_product_viewed", {
        product_id: options.content.id,
        product_name: options.title,
        vas_category: "oil",
        referral_location: ((_URLSearchParams = new URLSearchParams((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search)) === null || _URLSearchParams === void 0 ? void 0 : _URLSearchParams.get("referral")) || ""
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!data) return null;
  var gallery = data.find(function (c) {
    return c.component_type === "product_gallery";
  });
  var optionsSection = data.find(function (c) {
    return c.component_type === "product_options";
  });
  var featuresSection = data.find(function (c) {
    return c.component_type === "product_features";
  });
  var specsSection = data.find(function (c) {
    return c.component_type === "product_specs";
  });
  var faqSection = data.find(function (c) {
    return c.component_type === "faq";
  });
  var needHelpSection = data.find(function (c) {
    return c.component_type === "need_help";
  });
  var pageTitle = (_ref = (_gallery$title = gallery === null || gallery === void 0 ? void 0 : gallery.title) !== null && _gallery$title !== void 0 ? _gallery$title : optionsSection === null || optionsSection === void 0 ? void 0 : optionsSection.title) !== null && _ref !== void 0 ? _ref : "";
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    headHideLinks: true,
    disableLoader: true,
    hideOrangeHeadBtn: true,
    showUserAvatar: true,
    showCartIcon: __IS_CSR__,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobilePageHeader, {
      backUrl: "/products/oil",
      onShare: function onShare() {
        return setShowShare(true);
      }
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white min-h-screen pb-28"
  }, /*#__PURE__*/React.createElement("div", {
    className: "block py-4 md:py-6 px-4"
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    links: [{
      title: tShort("breadcrumb/oils", {
        ns: "web_oils"
      }),
      link: createUrl("/products/oil")
    }, {
      title: pageTitle
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-4 pb-2 md:px-6 md:pt-6 md:pb-4 md:max-w-[1200px] md:mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row md:gap-6 md:items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-[64%]"
  }, gallery && /*#__PURE__*/React.createElement(OilImageGallery, {
    gallery: gallery,
    title: pageTitle
  }), !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, featuresSection && /*#__PURE__*/React.createElement(OilProductDescription, {
    section: featuresSection
  }), specsSection && /*#__PURE__*/React.createElement(OilDetailsAccordion, {
    section: specsSection
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-[34%] pt-4 md:pt-0"
  }, optionsSection && /*#__PURE__*/React.createElement(OilProductSelection, {
    section: optionsSection,
    onShareOpen: function onShareOpen() {
      return setShowShare(true);
    }
  })))), isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, featuresSection && /*#__PURE__*/React.createElement(OilProductDescription, {
    section: featuresSection
  }), specsSection && /*#__PURE__*/React.createElement(OilDetailsAccordion, {
    section: specsSection
  })), faqSection && /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(OilFAQ, {
    section: faqSection
  })), needHelpSection && /*#__PURE__*/React.createElement(OilContactSection, {
    contact: needHelpSection.content
  })), /*#__PURE__*/React.createElement(OilStickyBar, null), /*#__PURE__*/React.createElement(OilShareModal, {
    isOpen: showShare,
    onClose: function onClose() {
      return setShowShare(false);
    },
    title: pageTitle,
    image: (_ref2 = (_gallery$content$ = gallery === null || gallery === void 0 ? void 0 : gallery.content[0]) !== null && _gallery$content$ !== void 0 ? _gallery$content$ : optionsSection === null || optionsSection === void 0 ? void 0 : optionsSection.content.logo) !== null && _ref2 !== void 0 ? _ref2 : ""
  }));
};
export default OilDetailPage;